/* eslint-disable no-unused-vars*/
/* eslint-disable new-cap*/
/* eslint-disable react/prop-types*/
import React, { Fragment } from 'react';
// import { Link } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import { usePermify } from '@permify/react-role';
import { Form, Input, Row } from 'antd';
import { Container, LoginContent, TextHeader } from './index.components.styles';
import { ColFlexEnd } from 'common/Container/container.styles';
// import { get } from 'lodash';
import Color from 'constants/color';
import { ButtonPrimary } from 'common/Button/Button.styles';
import { checkServerStatus, postLogin } from 'api/login';
import { parseJWT } from 'helper/jwt';
import { messageRequireIcon } from 'common/messageError/message.common';
import { handleError } from 'helper/rest';
import Swal from 'sweetalert2';

import { Typography } from 'antd';
const { Text } = Typography;
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

const IndexComponents = (props: any) => {
  const { setTokenData } = props;
  const [form] = Form.useForm();
  // const isMobileView = useSelector((state) => get(state, 'device.isMobileView', false));
  const { setUser } = usePermify();

  const [loadingLogin, setLoadingLogin] = useState(false);
  const [loginStatusText, setLoginStatusText] = useState<string | null>(null);

  const checkUntilOnline = () => {
    const interval = setInterval(async () => {
      const status = await checkServerStatus();
      console.log('🔄 Re-checking server status:', status);

      if (status === 'active') {
        clearInterval(interval);
        Swal.fire({
          icon: 'success',
          title: 'เซิร์ฟเวอร์เปิดแล้ว',
          text: 'กรุณากดเข้าสู่ระบบอีกครั้ง',
          confirmButtonText: 'ตกลง',
        });
        setLoginStatusText(null);
      }
    }, 30000);
  };

  const onFinish = async (values: any) => {
    setLoadingLogin(true);

    // const popup = Swal.fire({
    //   title: '⏳ กำลังตรวจสอบเซิร์ฟเวอร์',
    //   html: '<small>กรุณารอสักครู่...</small>',
    //   allowOutsideClick: false,
    //   allowEscapeKey: false,
    //   didOpen: () => {
    //     Swal.showLoading();
    //   },
    // });

    // const status = await checkServerStatus();
    // if (status !== 'active') {
    //   Swal.update({
    //     title: '🔴 เซิร์ฟเวอร์ไม่พร้อมใช้งาน',
    //     html: `ระบบกำลังเปิดเซิร์ฟเวอร์ให้คุณ กรุณารอสักครู่...<br/><small>ระบบจะเช็คสถานะทุก 30 วินาทีโดยอัตโนมัติ</small>`,
    //     icon: 'info',
    //     showCancelButton: true,
    //     cancelButtonText: 'ปิด',
    //     showConfirmButton: false,
    //     allowOutsideClick: true,
    //   });

    //   checkUntilOnline();
    //   setLoadingLogin(false);
    //   return;
    // }

    // Swal.update({
    //   icon: 'success',
    //   title: '🟢 เซิร์ฟเวอร์พร้อมใช้งาน',
    //   html: 'กำลังเข้าสู่ระบบ...',
    //   showConfirmButton: false,
    // });

    // ✅ เพิ่ม delay สัก 1 วินาทีให้ผู้ใช้เห็นข้อความ
    await new Promise(resolve => setTimeout(resolve, 1000));

    try {
      const responseData = await postLogin({ params: values });
      if (responseData?.status === 200) {
        const parsedJwt = parseJWT(responseData.data.data.token);
        await setUser({
          id: parsedJwt?.id,
          roles: parsedJwt?.role,
          permissions: parsedJwt?.permission,
        });
        await setTokenData(true);

        Swal.fire({
          icon: 'success',
          title: 'เข้าสู่ระบบสำเร็จ',
          text: 'กำลังเข้าสู่ระบบ...',
          timer: 1500,
          showConfirmButton: false,
        });
        Swal.close();
      } else {
        handleError(responseData);
        Swal.fire({
          icon: 'error',
          title: 'เข้าสู่ระบบไม่สำเร็จ',
          text: 'กรุณาตรวจสอบชื่อผู้ใช้และรหัสผ่านอีกครั้ง',
          confirmButtonText: 'ตกลง', // ✅ ปุ่มให้ผู้ใช้ปิด popup
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        html: '<b>ไม่สามารถเข้าสู่ระบบได้</b><br/>กรุณาลองใหม่อีกครั้ง',
        confirmButtonColor: '#d33', // สีแดง
        confirmButtonText: 'ปิดหน้าต่าง',
      });
    } finally {
      setLoadingLogin(false);
    }
  };

  const handleUsernameKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      form.getFieldInstance('password').focus();
    }
  };

  const LoginForm = () => {
    return (
      <Container>
        <div className="main-login-content">
          <div className="max-content">
            <div className="box">
              {/* <ImgLogo src={Logo} alt='Logo' /> */}
              <LoginContent className={'login-cpex-inactive'}>
                <div className="postion-ro-style">
                  <div className="or-style">
                    <div className="line-or" /> <TextHeader style={{ color: Color.white }}>Login</TextHeader>
                    <div className="line-or" />
                  </div>
                  <div className="clearfix mt-3 mb-4" />
                </div>

                <Form
                  name="normal_login"
                  className="login-form"
                  initialValues={{
                    remember: true,
                  }}
                  form={form}
                  onFinish={onFinish}
                >
                  <Form.Item name="username" rules={[{ required: true, message: messageRequireIcon('กรุณากรอกข้อมูล ชื่อผู้ใช้') }]}>
                    <Input
                      style={{ color: Color.ocean }}
                      size="large"
                      prefix={<PersonIcon style={{ color: Color.ocean }} />}
                      placeholder="ชื่อผู้ใช้"
                      onKeyPress={handleUsernameKeyPress}
                    />
                  </Form.Item>
                  <Form.Item name="password" rules={[{ required: true, message: messageRequireIcon('กรุณากรอกข้อมูล รหัสผ่าน') }]}>
                    <Input
                      size="large"
                      style={{ color: Color.ocean }}
                      prefix={<LockIcon style={{ color: Color.ocean }} />}
                      type="password"
                      placeholder="รหัสผ่าน"
                      autoComplete="false"
                    />
                  </Form.Item>
                  <Form.Item>
                    <Row>
                      <ColFlexEnd span={24}>
                        <ButtonPrimary size="large" htmlType="submit" loading={loadingLogin}>
                          <LockOpenIcon style={{ marginRight: 8 }} />
                          เข้าสู่ระบบ
                        </ButtonPrimary>
                      </ColFlexEnd>
                    </Row>
                  </Form.Item>
                </Form>
              </LoginContent>
            </div>
          </div>
        </div>
      </Container>
    );
  };
  return <Fragment>{LoginForm()}</Fragment>;
};

export default IndexComponents;
